const wasOrWere = (count: number) => (count === 1 ? 'was' : 'were');

export { wasOrWere };
